  <div #contextPopOver id="context-pop-over" [class.visible]="isPopoverVisible" [style.top.px]="popoverPosition.top"
    [style.left.px]="popoverPosition.left">
    <div class="context-pop-over-container">
      <div class="context-pop-over-option" *ngFor="let option of submenuOptions"
        (click)="onSubMenuOptionClick($event, option)">
        <span class="text">{{option.label}}</span>
      </div>
    </div>
  </div>
